import React from "react";

type HeaderProps = {
    title: string,
    description: string,
    children: React.ReactNode,
}

const Header: React.FC<HeaderProps> = ({
    title,
    description,
    children }) => {
    return <div className="pm-header-row">
        <div className="pm-header-content">
            <div className="pm-title-group">
                <h3 className="pm-title">{title}</h3>
                <p className="pm-subtitle">{description}</p>
            </div>
            <div className="pm-actions">
                {children}
            </div>
        </div>
    </div>
}

export default Header;